import React from "react";

const ThirdPlaceProfileIcon = () => {
  return (
    
    <svg
      width="40"
      height="65"
      viewBox="0 0 40 65"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M32.7353 10.3519C32.4927 10.1612 32.1981 10.0385 31.8851 9.99794C31.5721 9.95734 31.2532 10.0004 30.965 10.1223L25.6011 12.3686L22.4846 7.07728C22.3356 6.83025 22.1198 6.62481 21.8591 6.48189C21.5984 6.33897 21.3021 6.26367 21.0005 6.26367C20.6988 6.26367 20.4026 6.33897 20.1419 6.48189C19.8812 6.62481 19.6654 6.83025 19.5164 7.07728L16.3999 12.3686L11.036 10.1223C10.7471 10.0006 10.4279 9.95746 10.1144 9.99772C9.80085 10.038 9.50553 10.1601 9.26181 10.3501C9.01809 10.5402 8.83569 10.7907 8.73522 11.0733C8.63475 11.3559 8.62023 11.6593 8.69329 11.9493L11.3858 22.7614C11.4373 22.9708 11.5334 23.1681 11.6682 23.3414C11.8031 23.5147 11.9739 23.6605 12.1703 23.7698C12.4362 23.9197 12.7402 23.999 13.0501 23.9994C13.2008 23.9991 13.3506 23.979 13.4953 23.9395C18.4032 22.6616 23.5872 22.6616 28.4951 23.9395C28.9432 24.0505 29.4197 23.9894 29.8201 23.7698C30.0177 23.6619 30.1895 23.5165 30.3245 23.343C30.4595 23.1694 30.5548 22.9714 30.6046 22.7614L33.3077 11.9493C33.3799 11.6592 33.3646 11.3559 33.2634 11.0737C33.1623 10.7914 32.9793 10.5414 32.7353 10.3519Z" fill="#CD7F32"/>
      <ellipse cx="20.999" cy="3.57957" rx="3.52929" ry="3.57957" fill="#CD7F32"/>
      <ellipse cx="20.9995" cy="16.1085" rx="2.64697" ry="2.68467" fill="#964B00"/>
      <ellipse cx="33.7947" cy="9.39739" rx="2.20581" ry="2.23723" fill="#CD7F32"/>
      <ellipse cx="8.20581" cy="9.39739" rx="2.20581" ry="2.23723" fill="#CD7F32"/>
      <ellipse cx="14.3821" cy="17.4498" rx="1.32348" ry="1.34234" fill="#964B00"/>
      <ellipse cx="27.6174" cy="17.4498" rx="1.32348" ry="1.34234" fill="#964B00"/>
      <g clipPath="url(#clip0_4030_2853)">
        <mask id="mask0_4030_2853" style={{maskType:"luminance"}} maskUnits="userSpaceOnUse" x="0" y="25" width="40" height="40">
          <path d="M40 45C40 33.9543 31.0457 25 20 25C8.9543 25 0 33.9543 0 45C0 56.0457 8.9543 65 20 65C31.0457 65 40 56.0457 40 45Z" fill="white"/>
        </mask>
        <g mask="url(#mask0_4030_2853)">
          <path d="M40 25H0V65H40V25Z" fill="#979797"/>
          <path d="M-5.8571 51.5774C0.581554 61.8814 14.1542 65.0149 24.4582 58.5762C34.7622 52.1375 37.8957 38.5649 31.457 28.2609C25.0184 17.9569 11.4457 14.8234 1.14173 21.2621C-9.16228 27.7007 -12.2958 41.2734 -5.8571 51.5774Z" fill="#CCF900"/>
          <path d="M11.9844 43.4023C13.9651 44.5934 16.1527 44.9755 18.547 44.5487" stroke="black" strokeWidth="2.22222" strokeLinecap="round"/>
          <path d="M9.85378 37.6278C10.0022 37.0831 9.8041 36.5385 9.41134 36.4116C9.01859 36.2846 8.57989 36.6232 8.43148 37.168C8.28308 37.7127 8.48117 38.2573 8.87392 38.3843C9.26668 38.5113 9.70538 38.1726 9.85378 37.6278Z" fill="black"/>
          <path d="M23.0579 39.4833C23.2063 38.9386 23.0082 38.394 22.6154 38.267C22.2227 38.14 21.784 38.4787 21.6356 39.0235C21.4872 39.5682 21.6853 40.1128 22.078 40.2397C22.4708 40.3667 22.9095 40.0281 23.0579 39.4833Z" fill="black"/>
        </g>
      </g>
      <defs>
        <clipPath id="clip0_4030_2853">
          <rect width="40" height="40" fill="white" transform="translate(0 25)"/>
        </clipPath>
      </defs>
    </svg>
  );
};

export default ThirdPlaceProfileIcon;
